<template>
  <perfect-scrollbar data-mdb-smooth-scroll-init>
    <div class="sidebar-box">
      <div class="filter-title" v-if="apiType === 'API1'">Please select service type:</div>
      <div class="seat-type" v-if="isReturning && booking.activeLeg === 'leg2' && apiType === 'API1'">
        <div @click="changeClass('Economy', 'leg2')"
          v-if="airlinesLeg2.Economy.length || airlinesLeg2.loading.indexOf('Economy') > -1"
          :class="['type-box d-flex', {
            'non-avail': !airlinesLeg2.filtered.Economy.length && airlinesLeg2.loading.indexOf('Economy') > -1,
            disabled: !airlinesLeg2.filtered.Economy.length || airlinesLeg2.loading.indexOf('Economy') > -1,
            active: airlinesLeg2.selectedCabin === 'Economy'
          }]"
        >
          <div class="type-desc">
            <div class="type-name">Economy</div>
            <div class="flight-count">
              <span v-if="airlinesLeg2.loading.indexOf('Economy') > -1">
                <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="!appLoader"></i>
                Fetching flights...
              </span>
              <span v-else>{{airlinesLeg2.filtered.Economy.length}} flights found</span>
            </div>
          </div>
          <div class="type-price">
            <span class="empty-na" v-if="!airlinesLeg2.filtered.Economy.length || airlinesLeg2.loading.indexOf('Economy') > -1">
              <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="airlinesLeg2.loading.indexOf('Economy') > -1 && !appLoader"></i>
              <b v-if="!airlinesLeg2.filtered.Economy.length && airlinesLeg2.loading.indexOf('Economy') === -1">N/A</b>
            </span>
            <div v-else>
              <b v-if="currency.code === 'USD'">$ {{priceFormat(parseFloat((airlinesLeg2.filtered.Economy[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <b v-else>{{applyCurrency(parseFloat((airlinesLeg2.filtered.Economy[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <span>Starting Price</span>
            </div>
          </div>
        </div>
        <div @click="changeClass('PremiumEconomy', 'leg2')"
          v-if="airlinesLeg2.PremiumEconomy.length || airlinesLeg2.loading.indexOf('PremiumEconomy') > -1"
          :class="['type-box d-flex', {
            'non-avail': !airlinesLeg2.filtered.PremiumEconomy.length && airlinesLeg2.loading.indexOf('PremiumEconomy') > -1,
            disabled: !airlinesLeg2.filtered.PremiumEconomy.length || airlinesLeg2.loading.indexOf('PremiumEconomy') > -1,
            active: airlinesLeg2.selectedCabin === 'PremiumEconomy'
          }]"
        >
          <div class="type-desc">
            <div class="type-name">Premium Economy</div>
            <div class="flight-count">
              <span v-if="airlinesLeg2.loading.indexOf('PremiumEconomy') > -1">
                <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="!appLoader"></i>
                Fetching flights...
              </span>
              <span v-else>{{airlinesLeg2.filtered.PremiumEconomy.length}} flights found</span>
            </div>
          </div>
          <div class="type-price">
            <span class="empty-na" v-if="!airlinesLeg2.filtered.PremiumEconomy.length || airlinesLeg2.loading.indexOf('PremiumEconomy') > -1">
              <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="airlinesLeg2.loading.indexOf('PremiumEconomy') > -1 && !appLoader"></i>
              <b v-if="!airlinesLeg2.filtered.PremiumEconomy.length && airlinesLeg2.loading.indexOf('PremiumEconomy') === -1">N/A</b>
            </span>
            <div v-else>
              <b v-if="currency.code === 'USD'">$ {{priceFormat(parseFloat((airlinesLeg2.filtered.PremiumEconomy[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <b v-else>{{applyCurrency(parseFloat((airlinesLeg2.filtered.PremiumEconomy[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <span>Starting Price</span>
            </div>
          </div>
        </div>
        <div @click="changeClass('Business', 'leg2')"
          v-if="airlinesLeg2.Business.length || airlinesLeg2.loading.indexOf('Business') > -1"
          :class="['type-box d-flex', {
            'non-avail': !airlinesLeg2.filtered.Business.length && airlinesLeg2.loading.indexOf('Business') > -1,
            disabled: !airlinesLeg2.filtered.Business.length || airlinesLeg2.loading.indexOf('Business') > -1,
            active: airlinesLeg2.selectedCabin === 'Business'
          }]"
        >
          <div class="type-desc">
            <div class="type-name">Business</div>
            <div class="flight-count">
              <span v-if="airlinesLeg2.loading.indexOf('Business') > -1">
                <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="!appLoader"></i>
                Fetching flights...
              </span>
              <span v-else>{{airlinesLeg2.filtered.Business.length}} flights found
              </span>
            </div>
          </div>
          <div class="type-price">
            <span class="empty-na" v-if="!airlinesLeg2.filtered.Business.length || airlinesLeg2.loading.indexOf('Business') > -1">
              <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="airlinesLeg2.loading.indexOf('Business') > -1 && !appLoader"></i>
              <b v-if="!airlinesLeg2.filtered.Business.length && airlinesLeg2.loading.indexOf('Business') === -1">N/A</b>
            </span>
            <div v-else>
              <b v-if="currency.code === 'USD'">$ {{priceFormat(parseFloat((airlinesLeg2.filtered.Business[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <b v-else>{{applyCurrency(parseFloat((airlinesLeg2.filtered.Business[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <span>Starting Price</span>
            </div>
          </div>
        </div>
        <!-- <div @click="changeClass('PremiumBusiness', 'leg2')"
          v-if="airlinesLeg2.PremiumBusiness.length || airlinesLeg2.loading.indexOf('PremiumBusiness') > -1"
          :class="['type-box d-flex', {
            'non-avail': !airlinesLeg2.filtered.PremiumBusiness.length && airlinesLeg2.loading.indexOf('PremiumBusiness') > -1,
            disabled: !airlinesLeg2.filtered.PremiumBusiness.length || airlinesLeg2.loading.indexOf('PremiumBusiness') > -1,
            active: airlinesLeg2.selectedCabin === 'PremiumBusiness'
          }]"
        >
          <div class="type-desc">
            <div class="type-name">Premium Business</div>
            <div class="flight-count">
              <span v-if="airlinesLeg2.loading.indexOf('PremiumBusiness') > -1">
                <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="!appLoader"></i>
                Fetching flights...
              </span>
              <span v-else>{{airlinesLeg2.filtered.PremiumBusiness.length}} flights found
              </span>
            </div>
          </div>
          <div class="type-price">
            <span class="empty-na" v-if="!airlinesLeg2.filtered.PremiumBusiness.length || airlinesLeg2.loading.indexOf('PremiumBusiness') > -1">
              <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="airlinesLeg2.loading.indexOf('PremiumBusiness') > -1 && !appLoader"></i>
              <b v-if="!airlinesLeg2.filtered.PremiumBusiness.length && airlinesLeg2.loading.indexOf('PremiumBusiness') === -1">N/A</b>
            </span>
            <div v-else>
              <b v-if="currency.code === 'USD'">$ {{priceFormat(parseFloat((airlinesLeg2.filtered.PremiumBusiness[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <b v-else>{{applyCurrency(parseFloat((airlinesLeg2.filtered.PremiumBusiness[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <span>Starting Price</span>
            </div>
          </div>
        </div> -->
        <div @click="changeClass('First', 'leg2')"
          v-if="airlinesLeg2.First.length || airlinesLeg2.loading.indexOf('First') > -1"
          :class="['type-box d-flex', {
            'non-avail': !airlinesLeg2.filtered.First.length && airlinesLeg2.loading.indexOf('First') > -1,
            disabled: !airlinesLeg2.filtered.First.length || airlinesLeg2.loading.indexOf('First') > -1,
            active: airlinesLeg2.selectedCabin === 'First'
          }]"
        >
          <div class="type-desc">
            <div class="type-name">First Class</div>
            <div class="flight-count">
              <span v-if="airlinesLeg2.loading.indexOf('First') > -1">
                <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="!appLoader"></i>
                Fetching flights...
              </span>
              <span v-else>{{airlinesLeg2.filtered.First.length}} flights found
              </span>
            </div>
          </div>
          <div class="type-price">
            <span class="empty-na" v-if="!airlinesLeg2.filtered.First.length || airlinesLeg2.loading.indexOf('First') > -1">
              <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="airlinesLeg2.loading.indexOf('First') > -1 && !appLoader"></i>
              <b v-if="!airlinesLeg2.filtered.First.length && airlinesLeg2.loading.indexOf('First') === -1">N/A</b>
            </span>
            <div v-else>
              <b v-if="currency.code === 'USD'">$ {{priceFormat(parseFloat((airlinesLeg2.filtered.First[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <b v-else>{{applyCurrency(parseFloat((airlinesLeg2.filtered.First[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <span>Starting Price</span>
            </div>
          </div>
        </div>
      </div>
      <div class="seat-type" v-else-if="apiType === 'API1'">
        <div @click="changeClass('Economy', 'leg1')"
          v-if="airlinesLeg1.Economy.length || airlinesLeg1.loading.indexOf('Economy') > -1"
          :class="['type-box d-flex', {
            'non-avail': !airlinesLeg1.filtered.Economy.length && airlinesLeg1.loading.indexOf('Economy') > -1,
            disabled: !airlinesLeg1.filtered.Economy.length || airlinesLeg1.loading.indexOf('Economy') > -1,
            active: airlinesLeg1.selectedCabin === 'Economy'
          }]"
        >
          <div class="type-desc">
            <div class="type-name">Economy</div>
            <div class="flight-count">
              <span v-if="airlinesLeg1.loading.indexOf('Economy') > -1">
                <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="!appLoader"></i>
                Fetching flights...
              </span>
              <span v-else>{{airlinesLeg1.filtered.Economy.length}} flights found
              </span>
            </div>
          </div>
          <div class="type-price">
            <span class="empty-na" v-if="!airlinesLeg1.filtered.Economy.length || airlinesLeg1.loading.indexOf('Economy') > -1">
              <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="airlinesLeg1.loading.indexOf('Economy') > -1 && !appLoader"></i>
              <b v-if="!airlinesLeg1.filtered.Economy.length && airlinesLeg1.loading.indexOf('Economy') === -1">N/A</b>
            </span>
            <div v-else>
              <b v-if="currency.code === 'USD'">$ {{priceFormat(parseFloat((airlinesLeg1.filtered.Economy[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <b v-else>{{applyCurrency(parseFloat((airlinesLeg1.filtered.Economy[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <span>Starting Price</span>
            </div>
          </div>
        </div>
        <div @click="changeClass('PremiumEconomy', 'leg1')"
          v-if="airlinesLeg1.PremiumEconomy.length || airlinesLeg1.loading.indexOf('PremiumEconomy') > -1"
          :class="['type-box d-flex', {
            'non-avail': !airlinesLeg1.filtered.PremiumEconomy.length && airlinesLeg1.loading.indexOf('PremiumEconomy') > -1,
            disabled: !airlinesLeg1.filtered.PremiumEconomy.length || airlinesLeg1.loading.indexOf('PremiumEconomy') > -1,
            active: airlinesLeg1.selectedCabin === 'PremiumEconomy'
          }]"
        >
          <div class="type-desc">
            <div class="type-name">Premium Economy</div>
            <div class="flight-count">
              <span v-if="airlinesLeg1.loading.indexOf('PremiumEconomy') > -1">
                <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="!appLoader"></i>
                Fetching flights...
              </span>
              <span v-else>{{airlinesLeg1.filtered.PremiumEconomy.length}} flights found
              </span>
            </div>
          </div>
          <div class="type-price">
            <span class="empty-na" v-if="!airlinesLeg1.filtered.PremiumEconomy.length || airlinesLeg1.loading.indexOf('PremiumEconomy') > -1">
              <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="airlinesLeg1.loading.indexOf('PremiumEconomy') > -1 && !appLoader"></i>
              <b v-if="!airlinesLeg1.filtered.PremiumEconomy.length && airlinesLeg1.loading.indexOf('PremiumEconomy') === -1">N/A</b>
            </span>
            <div v-else>
              <b v-if="currency.code === 'USD'">$ {{priceFormat(parseFloat((airlinesLeg1.filtered.PremiumEconomy[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <b v-else>{{applyCurrency(parseFloat((airlinesLeg1.filtered.PremiumEconomy[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <span>Starting Price</span>
            </div>
          </div>
        </div>
        <div @click="changeClass('Business', 'leg1')"
          v-if="airlinesLeg1.Business.length || airlinesLeg1.loading.indexOf('Business') > -1"
          :class="['type-box d-flex', {
            'non-avail': !airlinesLeg1.filtered.Business.length && airlinesLeg1.loading.indexOf('Business') > -1,
            disabled: !airlinesLeg1.filtered.Business.length || airlinesLeg1.loading.indexOf('Business') > -1,
            active: airlinesLeg1.selectedCabin === 'Business'
          }]"
        >
          <div class="type-desc">
            <div class="type-name">Business</div>
            <div class="flight-count">
              <span v-if="airlinesLeg1.loading.indexOf('Business') > -1">
                <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="!appLoader"></i>
                Fetching flights...
              </span>
              <span v-else>{{airlinesLeg1.filtered.Business.length}} flights found</span>
            </div>
          </div>
          <div class="type-price">
            <span class="empty-na" v-if="!airlinesLeg1.filtered.Business.length || airlinesLeg1.loading.indexOf('Business') > -1">
              <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="airlinesLeg1.loading.indexOf('Business') > -1 && !appLoader"></i>
              <b v-if="!airlinesLeg1.filtered.Business.length && airlinesLeg1.loading.indexOf('Business') === -1">N/A</b>
            </span>
            <div v-else>
              <b v-if="currency.code === 'USD'">$ {{priceFormat(parseFloat((airlinesLeg1.filtered.Business[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <b v-else>{{applyCurrency(parseFloat((airlinesLeg1.filtered.Business[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <span>Starting Price</span>
            </div>
          </div>
        </div>
        <!-- <div @click="changeClass('PremiumBusiness', 'leg1')"
          v-if="airlinesLeg1.PremiumBusiness.length || airlinesLeg1.loading.indexOf('PremiumBusiness') > -1"
          :class="['type-box d-flex', {
            'non-avail': !airlinesLeg1.filtered.PremiumBusiness.length && airlinesLeg1.loading.indexOf('PremiumBusiness') > -1,
            disabled: !airlinesLeg1.filtered.PremiumBusiness.length || airlinesLeg1.loading.indexOf('PremiumBusiness') > -1,
            active: airlinesLeg1.selectedCabin === 'PremiumBusiness'
          }]"
        >
          <div class="type-desc">
            <div class="type-name">Premium Business</div>
            <div class="flight-count">
              <span v-if="airlinesLeg1.loading.indexOf('PremiumBusiness') > -1">
                <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="!appLoader"></i>
                Fetching flights...
              </span>
              <span v-else>{{airlinesLeg1.filtered.PremiumBusiness.length}} flights found</span>
            </div>
          </div>
          <div class="type-price">
            <span class="empty-na" v-if="!airlinesLeg1.filtered.PremiumBusiness.length || airlinesLeg1.loading.indexOf('PremiumBusiness') > -1">
              <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="airlinesLeg1.loading.indexOf('PremiumBusiness') > -1 && !appLoader"></i>
              <b v-if="!airlinesLeg1.filtered.PremiumBusiness.length && airlinesLeg1.loading.indexOf('PremiumBusiness') === -1">N/A</b>
            </span>
            <div v-else>
              <b v-if="currency.code === 'USD'">$ {{priceFormat(parseFloat((airlinesLeg1.filtered.PremiumBusiness[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <b v-else>{{applyCurrency(parseFloat((airlinesLeg1.filtered.PremiumBusiness[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <span>Starting Price</span>
            </div>
          </div>
        </div> -->
        <div @click="changeClass('First', 'leg1')"
          v-if="airlinesLeg1.First.length || airlinesLeg1.loading.indexOf('First') > -1"
          :class="['type-box d-flex', {
            'non-avail': !airlinesLeg1.filtered.First.length && airlinesLeg1.loading.indexOf('First') > -1,
            disabled: !airlinesLeg1.filtered.First.length || airlinesLeg1.loading.indexOf('First') > -1,
            active: airlinesLeg1.selectedCabin === 'First'
          }]"
        >
          <div class="type-desc">
            <div class="type-name">First Class</div>
            <div class="flight-count">
              <span v-if="airlinesLeg1.loading.indexOf('First') > -1">
                <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="!appLoader"></i>
                Fetching flights...
              </span>
              <span v-else>{{airlinesLeg1.filtered.First.length}} flights found</span>
            </div>
          </div>
          <div class="type-price">
            <span class="empty-na" v-if="!airlinesLeg1.filtered.First.length || airlinesLeg1.loading.indexOf('First') > -1">
              <i class="fas fa-spinner fa-spin slow-spin fa-fw" v-if="airlinesLeg1.loading.indexOf('First') > -1 && !appLoader"></i>
              <b v-if="!airlinesLeg1.filtered.First.length && airlinesLeg1.loading.indexOf('First') === -1">N/A</b>
            </span>
            <div v-else>
              <b v-if="currency.code === 'USD'">$ {{priceFormat(parseFloat((airlinesLeg1.filtered.First[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <b v-else>{{applyCurrency(parseFloat((airlinesLeg1.filtered.First[0].payment.totalWithMarkUp + otherLegPrice()).toFixed(2)))}}</b>
              <span>Starting Price</span>
            </div>
          </div>
        </div>
      </div>

      <hr class="show-on-mobile" v-if="apiType === 'API1'" />

      <div class="show-on-mobile sb-sort">
        <label>Sort by</label>
        <select v-model="filters.sort">
          <option value="price-low-to-high">Price: low to high</option>
          <option value="price-high-to-low">Price: high to low</option>
        </select>
      </div>

      <hr v-if="apiType === 'API1'" />

      <div class="filter-title">Airlines</div>
      <perfect-scrollbar data-mdb-smooth-scroll-init class="airline-scroll">
        <ul class="airline-list">
          <li v-show="airlinesLeg1.selectedCabin === 'API2' && booking.activeLeg === 'leg1'"
            v-for="(airline, i) in airlinesLeg1.unique.API2" :key="`leg1${i}`"
            :class="{active:filters.airlines.leg1.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <div class="d-flex al-name">
              <img :src="airline.logo" />
              <span>{{airline.name}}</span>
            </div>
            <div class="al-price">
              <span v-if="currency.code === 'USD'">$ {{parseFloat(airline.price + lowestAirlinePriceLeg2(airline.name)).toFixed(2)}}</span>
              <span v-else-if="currency.code !== 'USD'">{{ applyCurrency(airline.price + lowestAirlinePriceLeg2(airline.name))}}</span>
            </div>
          </li>
          <li v-show="airlinesLeg1.selectedCabin === 'Economy' && booking.activeLeg === 'leg1'"
            v-for="(airline, i) in airlinesLeg1.unique.Economy" :key="`leg1${i}`"
            :class="{active:filters.airlines.leg1.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <img :src="airline.logo" />
            <span>{{airline.name}}</span>
          </li>
          <li v-show="airlinesLeg1.selectedCabin === 'PremiumEconomy' && booking.activeLeg === 'leg1'"
            v-for="(airline, i) in airlinesLeg1.unique.PremiumEconomy" :key="`leg1${i}`"
            :class="{active:filters.airlines.leg1.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <img :src="airline.logo" />
            <span>{{airline.name}}</span>
          </li>
          <li v-show="airlinesLeg1.selectedCabin === 'Business' && booking.activeLeg === 'leg1'"
            v-for="(airline, i) in airlinesLeg1.unique.Business" :key="`leg1${i}`"
            :class="{active:filters.airlines.leg1.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <img :src="airline.logo" />
            <span>{{airline.name}}</span>
          </li>
          <li v-show="airlinesLeg1.selectedCabin === 'PremiumBusiness' && booking.activeLeg === 'leg1'"
            v-for="(airline, i) in airlinesLeg1.unique.PremiumBusiness" :key="`leg1${i}`"
            :class="{active:filters.airlines.leg1.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <img :src="airline.logo" />
            <span>{{airline.name}}</span>
          </li>
          <li v-show="airlinesLeg1.selectedCabin === 'First' && booking.activeLeg === 'leg1'"
            v-for="(airline, i) in airlinesLeg1.unique.First" :key="`leg1${i}`"
            :class="{active:filters.airlines.leg1.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <img :src="airline.logo" />
            <span>{{airline.name}}</span>
          </li>

          <li v-show="airlinesLeg2.selectedCabin === 'API2' && booking.activeLeg === 'leg2'"
            v-for="(airline, i) in airlinesLeg2.unique.API2" :key="`leg2${i}`"
            :class="{active:filters.airlines.leg2.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <div>
              <img :src="airline.logo" />
              <span>{{airline.name}}</span>
            </div>
            <div>
              <span v-if="currency.code === 'USD'">$ {{parseFloat(airline.price - lowestAirlinePriceLeg2(airline.name)).toFixed(2)}}</span>
              <span v-else-if="currency.code !== 'USD'">{{ applyCurrency(airline.price - lowestAirlinePriceLeg2(airline.name))}}</span>
            </div>
          </li>
          <li v-show="airlinesLeg2.selectedCabin === 'Economy' && booking.activeLeg === 'leg2'"
            v-for="(airline, i) in airlinesLeg2.unique.Economy" :key="`leg2${i}`"
            :class="{active:filters.airlines.leg2.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <img :src="airline.logo" />
            <span>{{airline.name}}</span>
          </li>
          <li v-show="airlinesLeg2.selectedCabin === 'PremiumEconomy' && booking.activeLeg === 'leg2'"
            v-for="(airline, i) in airlinesLeg2.unique.PremiumEconomy" :key="`leg2${i}`"
            :class="{active:filters.airlines.leg2.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <img :src="airline.logo" />
            <span>{{airline.name}}</span>
          </li>
          <li v-show="airlinesLeg2.selectedCabin === 'Business' && booking.activeLeg === 'leg2'"
            v-for="(airline, i) in airlinesLeg2.unique.Business" :key="`leg2${i}`"
            :class="{active:filters.airlines.leg2.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <img :src="airline.logo" />
            <span>{{airline.name}}</span>
          </li>
          <li v-show="airlinesLeg2.selectedCabin === 'PremiumBusiness' && booking.activeLeg === 'leg2'"
            v-for="(airline, i) in airlinesLeg2.unique.PremiumBusiness" :key="`leg2${i}`"
            :class="{active:filters.airlines.leg2.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <img :src="airline.logo" />
            <span>{{airline.name}}</span>
          </li>
          <li v-show="airlinesLeg2.selectedCabin === 'First' && booking.activeLeg === 'leg2'"
            v-for="(airline, i) in airlinesLeg2.unique.First" :key="`leg2${i}`"
            :class="{active:filters.airlines.leg2.indexOf(airline.name) > -1}"
            @click="toggleAirline(airline.name)">
            <img :src="airline.logo" />
            <span>{{airline.name}}</span>
          </li>
        </ul>
      </perfect-scrollbar>

      <hr/>

      <div class="filter-title">Flight Stops</div>
      <ul class="time-list">
        <li @click="toggleStop(0)">
          <div v-if="isReturning && booking.activeLeg === 'leg2'">
            <i class="fas fa-check-square fa-fw" v-if="flightStopReturn.indexOf(0) > -1"></i>
            <i class="far fa-square fa-fw" v-else></i>
            Nonstop Flight
          </div>
          <div v-else>
            <i class="fas fa-check-square fa-fw" v-if="flightStop.indexOf(0) > -1"></i>
            <i class="far fa-square fa-fw" v-else></i>
            Nonstop Flight
          </div>
        </li>
        <li @click="toggleStop(1)">
          <div v-if="isReturning && booking.activeLeg === 'leg2'">
            <i class="fas fa-check-square fa-fw" v-if="flightStopReturn.indexOf(1) > -1"></i>
            <i class="far fa-square fa-fw" v-else></i>
            1 Stop
          </div>
          <div v-else>
            <i class="fas fa-check-square fa-fw" v-if="flightStop.indexOf(1) > -1"></i>
            <i class="far fa-square fa-fw" v-else></i>
            1 Stop
          </div>
        </li>
        <li @click="toggleStop(2)">
          <div v-if="isReturning && booking.activeLeg === 'leg2'">
            <i class="fas fa-check-square fa-fw" v-if="flightStopReturn.indexOf(2) > -1"></i>
            <i class="far fa-square fa-fw" v-else></i>
            2 Stops
          </div>
          <div v-else>
            <i class="fas fa-check-square fa-fw" v-if="flightStop.indexOf(2) > -1"></i>
            <i class="far fa-square fa-fw" v-else></i>
            2 Stops
          </div>
        </li>
        <li @click="toggleStop(3)">
          <div v-if="isReturning && booking.activeLeg === 'leg2'">
            <i class="fas fa-check-square fa-fw" v-if="flightStopReturn.indexOf(3) > -1"></i>
            <i class="far fa-square fa-fw" v-else></i>
            3 Stops
          </div>
          <div v-else>
            <i class="fas fa-check-square fa-fw" v-if="flightStop.indexOf(3) > -1 && airlinesReturn.active === 'leg1'"></i>
            <i class="far fa-square fa-fw" v-else></i>
            3 Stops
          </div>
        </li>
      </ul>

      <hr />

      <div v-if="booking.activeLeg === 'leg1'">
        <div class="filter-title">Departure Time <span v-if="isReturning">(First Flight)</span></div>
        <ul class="time-list">
          <li v-for="(time, i) in timeOptions" :key="i" @click="toggleTime('departure', time.key)">
            <div>
              <i class="fas fa-check-square fa-fw" v-if="departure[time.key]"></i>
              <i class="far fa-square fa-fw" v-else></i>
              {{time.label1}}
            </div>
            <span class="time-val">{{ time.label2 }}</span>
          </li>
        </ul>

        <div class="filter-title">Arrival Time <span v-if="isReturning">(First Flight)</span></div>
        <ul class="time-list">
          <li v-for="(time, i) in timeOptions" :key="i" @click="toggleTime('arrival', time.key)">
            <div>
              <i class="fas fa-check-square fa-fw" v-if="arrival[time.key]"></i>
              <i class="far fa-square fa-fw" v-else></i>
              {{time.label1}}
            </div>
            <span class="time-val">{{ time.label2 }}</span>
          </li>
        </ul>
      </div>
      <div v-if="isReturning && (booking.activeLeg === 'leg2' || !isCustomFlight)">
        <div class="filter-title">Departure Time <span>(Return Flight)</span></div>
        <ul class="time-list">
          <li v-for="(time, i) in timeOptions" :key="i" @click="toggleTime('departureReturn', time.key)">
            <div>
              <i class="fas fa-check-square fa-fw" v-if="departureReturn[time.key]"></i>
              <i class="far fa-square fa-fw" v-else></i>
              {{time.label1}}
            </div>
            <span class="time-val">{{ time.label2 }}</span>
          </li>
        </ul>

        <div class="filter-title">Arrival Time <span>(Return Flight)</span></div>
        <ul class="time-list">
          <li v-for="(time, i) in timeOptions" :key="i" @click="toggleTime('arrivalReturn', time.key)">
            <div>
              <i class="fas fa-check-square fa-fw" v-if="arrivalReturn[time.key]"></i>
              <i class="far fa-square fa-fw" v-else></i>
              {{time.label1}}
            </div>
            <span class="time-val">{{ time.label2 }}</span>
          </li>
        </ul>
      </div>

      <!-- <div class="filter-title">Price</div>
      <div class="price-range">
        <span v-if="isReturning && booking.activeLeg === 'leg2'">{{applyCurrency(minPriceReturn)}}</span>
        <span v-else>{{applyCurrency(minPrice)}}</span>
        <span>-</span>
        <span v-if="isReturning && booking.activeLeg === 'leg2'">{{applyCurrency(maxPriceReturn)}}</span>
        <span v-else>{{applyCurrency(maxPrice)}}</span>
      </div>
      <MultiRangeSlider
        class="slider"
        :min="0" :max="40000" :step="100"
        :ruler="false" :label="false"
        :minValue="minPriceReturn"
        :maxValue="maxPriceReturn"
        @input="UpdateValues"
        v-if="isReturning && booking.activeLeg === 'leg2'"
      />
      <MultiRangeSlider
        class="slider"
        :min="0" :max="40000" :step="100"
        :ruler="false" :label="false"
        :minValue="minPrice"
        :maxValue="maxPrice"
        @input="UpdateValues"
        v-else
      />
      <label class="refundable">
        <input type="checkbox" v-model="refundableOnly" :disabled="filters.loading" />
        Show only refundable flights.
      </label>

      <hr/> -->
    </div>
  </perfect-scrollbar>
</template>

<script>
/* // global CONFIG */
import moment from 'moment-timezone'
import MultiRangeSlider from "multi-range-slider-vue"
// import booking from '@/modules/api/booking'
import xcurrency from '@/modules/api/currency'
// import trackError from '@/modules/api/track-error'
import servicePrice from '@/modules/api/service-price'

export default {
  name: 'service-selection',
  components: { MultiRangeSlider },
  data () {
    return {
      legTab: 1,
      departure: {
        earlyMorning: false,
        morning: false,
        midDay: false,
        evening: false
      },
      arrival: {
        earlyMorning: false,
        morning: false,
        midDay: false,
        evening: false
      },
      departureReturn: {
        earlyMorning: false,
        morning: false,
        midDay: false,
        evening: false
      },
      arrivalReturn: {
        earlyMorning: false,
        morning: false,
        midDay: false,
        evening: false
      },
      timeOptions: [
        {
          key: 'earlyMorning',
          label1: 'Early Morning',
          label2: '12-6AM'
        },
        {
          key: 'morning',
          label1: 'Morning',
          label2: '6-12PM'
        },
        {
          key: 'midDay',
          label1: 'Mid-Day',
          label2: '12-6PM'
        },
        {
          key: 'evening',
          label1: 'Evening',
          label2: '6-12AM'
        }
      ],
      priceFilterDelay: '',
      flightStop: [],
      flightStopReturn: []
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    locations () { return this.booking.locations },
    filters () { return this.booking.filters },
    isReturning () { return this.filters.departure.isReturning },
    minPrice () { return this.filters.minPrice },
    maxPrice () { return this.filters.maxPrice },
    minPriceReturn () { return this.filters.minPriceReturn },
    maxPriceReturn () { return this.filters.maxPriceReturn },
    airlines () { return this.booking.airlines },
    airlinesLeg1 () { return this.airlines.leg1 },
    airlinesLeg2 () { return this.airlines.leg2 },
    refundableOnly: {
      get () { return this.filters.refundableOnly },
      set (x) {
        this.$store.commit('booking/setFiltersData', {refundableOnly: x})
        this.applyFilter()
      }
    },
    filterSort () { return this.filters.sort },
    _applyFilter () { return this.filters.applyFilter },
    _api2FilterLeg1 () { return this._applyFilter.leg1.API2 },
    _economyFilterLeg1 () { return this._applyFilter.leg1.Economy },
    _premiumEconomyFilterLeg1 () { return this._applyFilter.leg1.PremiumEconomy },
    _businessFilterLeg1 () { return this._applyFilter.leg1.Business },
    _premiumBusinessFilterLeg1 () { return this._applyFilter.leg1.PremiumBusiness },
    _firstFilterLeg1 () { return this._applyFilter.leg1.First },
    _api2FilterLeg2 () { return this._applyFilter.leg2.API2 },
    _economyFilterLeg2 () { return this._applyFilter.leg2.Economy },
    _premiumEconomyFilterLeg2 () { return this._applyFilter.leg2.PremiumEconomy },
    _businessFilterLeg2 () { return this._applyFilter.leg2.Business },
    _premiumBusinessFilterLeg2 () { return this._applyFilter.leg2.PremiumBusiness },
    _firstFilterLeg2 () { return this._applyFilter.leg2.First },

    other () { return this.$store.state.other },
    currency () { return this.other.currency },
    appLoader () { return this.$store.state.other.appLoader },
    sessionModal () { return this.$store.state.global.sessionModal },
    apiType () { return this.booking.apiType },
    isCustomFlight () { return this.booking.settings.customFlight }
  },
  methods: {
    changeClass (cabin, leg) {
      if (this.airlines[leg].selectedCabin === cabin) return

      let tmp = {}
      tmp[leg] = []
      this.$store.commit('booking/seFiltersAirlinesData', tmp)
      this.$store.commit('booking/setAirlinesLegData', {
        leg: leg,
        fields: {selectedCabin: cabin}
      })
      this.applyFilter(cabin, leg, true, true)
      this.$store.commit('booking/setOthersData', {servicesPage: 10})
    },
    resetFilters () {
      let dateFilter = {
        earlyMorning: false,
        morning: false,
        midDay: false,
        evening: false
      }
      this.departure = dateFilter
      this.arrival = dateFilter
      this.departureReturn = dateFilter
      this.arrivalReturn = dateFilter

      this.$store.commit('booking/setFiltersData', {
        airlines: {leg1: [], leg2: []},
        minPriceReturn: 0,
        maxPriceReturn: 40000
      })
      this.refundableOnly = false

      this.flightStop = []
      this.flightStopReturn = []
    },
    priceFormat (data) {
      return parseFloat(data.toFixed(2)).toLocaleString('en-US')
    },
    UpdateValues (e) {
      let self = this
      let tmp = {
        minPrice: e.minValue,
        maxPrice: e.maxValue
      }
      if (self.isReturning && self.booking.activeLeg === 'leg2') {
        tmp = {
          minPriceReturn: e.minValue,
          maxPriceReturn: e.maxValue
        }
      }
      self.$store.commit('booking/setFiltersData', tmp)

      if (self.priceFilterDelay) clearTimeout(self.priceFilterDelay)
      self.priceFilterDelay = setTimeout(function () {
        self.applyFilter()
      }, 800)
    },
    toggleAirline (val) {
      let self = this
      let leg = self.booking.activeLeg
      let index = self.filters.airlines[leg].indexOf(val)
      if (index === -1) self.filters.airlines[leg].push(val)
      else self.filters.airlines[leg].splice(index, 1)
      self.$nextTick(() => {
        self.applyFilter()
        if (self.apiType === 'API2' && self.isReturning) self.applyFilter('API2', self.booking.activeLeg === 'leg1' ? 'leg2' : 'leg1')
      })

      if (window.gtag) { // eslint-disable-line
        gtag( // eslint-disable-line
          'event',
          'D2DService - Airlines',
          {value: val}
        )
      }
    },
    toggleTime (type, field) {
      this[type][field] = !this[type][field]
      this.applyFilter()
      if (this.apiType === 'API2' && this.isCustomFlight) {
        let type2 = type === 'departure' ? 'departureReturn' : 'departure'
        if (type.indexOf('arrival') > -1) type2 = type === 'arrival' ? 'arrivalReturn' : 'arrival'
        this[type2][field] = this[type][field]
        if (this.isReturning) this.applyFilter('API2', this.booking.activeLeg === 'leg1' ? 'leg2' : 'leg1')
      }

      if (window.gtag) { // eslint-disable-line
        let timeLabel = {
          earlyMorning: 'Early Morning',
          morning: 'Morning',
          midDay: 'Mid-Day',
          evening: 'Evening'
        }
        let time = []
        for (var key in this[type]) {
          if (this[type].hasOwnProperty(key) && this[type][key]) {
            time.push(timeLabel[key])
          }
        }
        let eventName = 'Departure_Time'
        if (type === 'arrival') eventName = 'Arrival_Time'
        if (type === 'departureReturn') eventName = 'Departure_Return_Time'
        if (type === 'arrivalReturn') eventName = 'Arrival_Return_Time'
        gtag( // eslint-disable-line
          'event',
          `D2Dservice - ${eventName}`,
          {value: time}
        )
      }
    },
    toggleStop (x) {
      let flightStop = this.booking.activeLeg === 'leg1' ? this.flightStop : this.flightStopReturn
      let index = flightStop.indexOf(x)
      if (this.apiType === 'API2') {
        if (index === -1) {
          this.flightStop.push(x)
          this.flightStopReturn.push(x)
        } else {
          this.flightStop.splice(index, 1)
          this.flightStopReturn.splice(index, 1)
        }
        if (this.isReturning) this.applyFilter('API2', this.booking.activeLeg === 'leg1' ? 'leg2' : 'leg1')
      } else {
        if (index === -1) flightStop.push(x)
        else flightStop.splice(index, 1)
      }

      this.applyFilter()
    },
    applyFilter (type, leg, showLoading = true, updateSelectedCabin = false, filterOtherLeg = true) {
      let self = this
      if (showLoading) self.$store.commit('booking/setFiltersData', {loading: true})
      if (!leg) leg = self.booking.activeLeg

      if (typeof type === 'undefined') {
        type = self.airlines[leg].selectedCabin
        let cabins = [...self.booking.cabinList]
        let filteredCabins = cabins.filter(e => { return e !== type })
        filteredCabins.forEach(x => {
          self.applyFilter(x, leg, true, false)
        })
      }
      let data = this.airlines[leg][type]
      let newData = this.airlines[leg][type]

      // filter via airline
      if (self.filters.airlines[leg].length) {
        newData = data.filter(x => self.filters.airlines[leg].indexOf(x.flightName) > -1)
      }

      // filter via price
      let minPrice = leg === 'leg1' ? 'minPrice' : 'minPriceReturn'
      let maxPrice = leg === 'leg1' ? 'maxPrice' : 'maxPriceReturn'
      newData = newData.filter(x => x.payment.totalWithMarkUp >= self.filters[minPrice] && x.payment.totalWithMarkUp <= self.filters[maxPrice])

      // filter via refundable
      if (self.refundableOnly) {
        newData = newData.filter(x => x.isRefundable === true)
      }

      // filter via stops
      let flightStop = leg === 'leg1' ? self.flightStop : self.flightStopReturn
      if (flightStop.length) {
        newData = newData.filter(x => {
          return (flightStop.indexOf(0) > -1 && x.flight.length - 1 === 0) ||
            (flightStop.indexOf(1) > -1 && x.flight.length - 1 === 1) ||
            (flightStop.indexOf(2) > -1 && x.flight.length - 1 === 2) ||
            (flightStop.indexOf(3) > -1 && x.flight.length - 1 === 3)
        })
      }

      // filter via Departure/Arrival Time
      let earlyMorning = { start: moment('00:00', 'HH:mm').subtract(1, 'minutes'), end: moment('06:00', 'HH:mm').add(1, 'minutes') }
      let morning = { start: moment('06:00', 'HH:mm'), end: moment('12:00', 'HH:mm').add(1, 'minutes') }
      let midDay = { start: moment('12:00', 'HH:mm'), end: moment('18:00', 'HH:mm').add(1, 'minutes') }
      let evening = { start: moment('18:00', 'HH:mm'), end: moment('24:00', 'HH:mm') }

      let departure = leg === 'leg1' ? self.departure : self.departureReturn
      let arrival = leg === 'leg1' ? self.arrival : self.arrivalReturn
      if (departure.earlyMorning || departure.morning || departure.midDay || departure.evening) {
        newData = newData.filter(x => {
          let origin = moment(x.flight[0].origin.DateTime, '@@@@-@@-@@ HH:mm')
          return (departure.earlyMorning && origin.isBetween(earlyMorning.start, earlyMorning.end)) ||
            (departure.morning && origin.isBetween(morning.start, morning.end)) ||
            (departure.midDay && origin.isBetween(midDay.start, midDay.end)) ||
            (departure.evening && origin.isBetween(evening.start, evening.end))
        })
      }
      if (arrival.earlyMorning || arrival.morning || arrival.midDay || arrival.evening) {
        newData = newData.filter(x => {
          let destination = moment(x.flight[x.flight.length - 1].destination.DateTime, '@@@@-@@-@@ HH:mm')
          return (arrival.earlyMorning && destination.isBetween(earlyMorning.start, earlyMorning.end)) ||
            (arrival.morning && destination.isBetween(morning.start, morning.end)) ||
            (arrival.midDay && destination.isBetween(midDay.start, midDay.end)) ||
            (arrival.evening && destination.isBetween(evening.start, evening.end))
        })
      }
      if (!self.isCustomFlight && self.isReturning) {
        if (self.departureReturn.earlyMorning || self.departureReturn.morning || self.departureReturn.midDay || self.departureReturn.evening) {
          newData = newData.filter(x => {
            let originReturn = moment(x.returnFlight[0].origin.DateTime, '@@@@-@@-@@ HH:mm')
            return (self.departureReturn.earlyMorning && originReturn.isBetween(earlyMorning.start, earlyMorning.end)) ||
              (self.departureReturn.morning && originReturn.isBetween(morning.start, morning.end)) ||
              (self.departureReturn.midDay && originReturn.isBetween(midDay.start, midDay.end)) ||
              (self.departureReturn.evening && originReturn.isBetween(evening.start, evening.end))
          })
        }
        if (self.arrivalReturn.earlyMorning || self.arrivalReturn.morning || self.arrivalReturn.midDay || self.arrivalReturn.evening) {
          newData = newData.filter(x => {
            let destinationReturn = moment(x.returnFlight[x.returnFlight.length - 1].destination.DateTime, '@@@@-@@-@@ HH:mm')
            return (self.arrivalReturn.earlyMorning && destinationReturn.isBetween(earlyMorning.start, earlyMorning.end)) ||
              (self.arrivalReturn.morning && destinationReturn.isBetween(morning.start, morning.end)) ||
              (self.arrivalReturn.midDay && destinationReturn.isBetween(midDay.start, midDay.end)) ||
              (self.arrivalReturn.evening && destinationReturn.isBetween(evening.start, evening.end))
          })
        }
      }

      if (self.filterSort === 'price-low-to-high') {
        newData.sort((a, b) => { return a.payment.total - b.payment.total })
      } else if (self.filterSort === 'price-high-to-low') {
        newData.sort((a, b) => { return b.payment.total - a.payment.total })
      }

      setTimeout(function () {
        let tmpObj = {}
        tmpObj[type] = newData
        self.$store.commit('booking/setAirlinesFilteredData', {
          leg: leg,
          fields: tmpObj
        })
        if (updateSelectedCabin) {
          self.$store.commit('booking/setAirlinesLegData', {
            leg: leg,
            selectedCabin: type
          })
        }
        self.$store.commit('booking/setFiltersData', {loading: false})
      }, 300)
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) {
        return parseFloat(x.toFixed(2))
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
    },
    otherLegPrice () {
      return servicePrice.otherLegPrice(this, this.booking.activeLeg)
    },
    lowestAirlinePriceLeg2 () {
      if (!this.isReturning) return 0

      // let leg2 = this.airlinesLeg2.unique[this.airlinesLeg2.selectedCabin].find(x => x.name === airline)
      let uniqueAirlineLeg2 = this.airlinesLeg2.unique[this.airlinesLeg2.selectedCabin]
      if (!uniqueAirlineLeg2.length) return 0
      let minLeg2 = uniqueAirlineLeg2.reduce((min, obj) => {
        return obj.price < min ? obj.price : min;
      }, Infinity)
      return minLeg2
    }
  },
  watch: {
    _api2FilterLeg1 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg1', fields: {API2: false}})
        this.applyFilter('API2', 'leg1')
      }
    },
    _economyFilterLeg1 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg1', fields: {Economy: false}})
        this.applyFilter('Economy', 'leg1')
      }
    },
    _premiumEconomyFilterLeg1 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg1', fields: {PremiumEconomy: false}})
        this.applyFilter('PremiumEconomy', 'leg1')
      }
    },
    _businessFilterLeg1 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg1', fields: {Business: false}})
        this.applyFilter('Business', 'leg1')
      }
    },
    _premiumBusinessFilterLeg1 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg1', fields: {PremiumBusiness: false}})
        this.applyFilter('PremiumBusiness', 'leg1')
      }
    },
    _firstFilterLeg1 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg1', fields: {First: false}})
        this.applyFilter('First', 'leg1')
      }
    },
    _api2FilterLeg2 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg2', fields: {API2: false}})
        this.applyFilter('API2', 'leg2')
      }
    },
    _economyFilterLeg2 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg2', fields: {Economy: false}})
        this.applyFilter('Economy', 'leg2')
      }
    },
    _premiumEconomyFilterLeg2 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg2', fields: {PremiumEconomy: false}})
        this.applyFilter('PremiumEconomy', 'leg2')
      }
    },
    _businessFilterLeg2 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg2', fields: {Business: false}})
        this.applyFilter('Business', 'leg2')
      }
    },
    _premiumBusinessFilterLeg2 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg2', fields: {PremiumBusiness: false}})
        this.applyFilter('PremiumBusiness', 'leg2')
      }
    },
    _firstFilterLeg2 (val) {
      if (val) {
        this.$store.commit('booking/setApplyFilter', {leg: 'leg2', fields: {First: false}})
        this.applyFilter('First', 'leg2')
      }
    },
    filterSort () {
      this.applyFilter()
    }
  },
  created () {
    if (!this.booking.filters.departure.date) {
      this.$root.$router.push('search')
      return
    }
  },
  mounted () {
    let self = this
    if (!self.booking.filters.departure.date) return

    // let cabins = [...self.booking.cabinList]
    // cabins.forEach(x => {
    //   self.applyFilter(x, 'leg1')
    //   if (self.isReturning) self.applyFilter(x, 'leg2')
    // })
    let leg1 = self.filters.applyFilter.leg1
    let leg2 = self.filters.applyFilter.leg2
    for (var key in leg1) {
      if (leg1[key]) {
        let tmp1 = {leg: 'leg1', fields: {}}
        tmp1.fields[key] = false
        self.$store.commit('booking/setApplyFilter', tmp1)
        self.applyFilter(key, 'leg1')
      }
      if (leg2[key]) {
        let tmp2 = {leg: 'leg2', fields: {}}
        tmp2.fields[key] = false
        self.$store.commit('booking/setApplyFilter', tmp2)
        self.applyFilter(key, 'leg2')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-box{
  border-right: 1px solid #B3B3B5;
  border-radius: 2px;
  background: #fff;
}
hr{
  margin: 0 10px;
  border-color: #ddd;
  border-top: none;
}
.show-on-mobile{
  display: none;
}
.sb-sort{
  padding: 20px 15px;

  label{
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
  }
  select{
    padding: 10px 5px;
    border-color: #a9a9a9;
  }
}
.airport-box{
  padding: 20px 20px;
  border-bottom: 1px solid #ccc;

  label{
    font-weight: 600;
    font-size: 15px;
    line-height: 1;
  }
  select{
    padding: 7px 10px;
    margin-bottom: 7px;
  }
}
.seat-type{
  padding: 3px 15px 15px;
  background: #fafafa;
}
.type-box{
  border: 2px solid #a5a5a5;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  margin-bottom: 5px;

  &:not(.non-avail):hover{
    border: 2px solid #edb545;
  }
  &:not(.non-avail).active{
    border: 2px solid #edb545;
    background: #fff;
  }
  &.non-avail{
    opacity: .8;
    cursor: default;
  }
}
.type-desc{
  width: 100%;
  padding: 7px 10px;
  line-height: 1;
}
.type-name{
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 4px;
}
.flight-count{
  color: #888;
  font-size: 14px;
}
.type-price{
  padding:7px;
  text-align: center;
  width: 200px;
  border-left: 1px solid #ddd;
  background: #f4f5f8;
  border-radius: 0 2px 2px 0;

  span{
    display: block;
    line-height: 1.2;
    font-size: 12px;
    // color: #eee;
  }
  b{
    font-size: 14px;
    line-height: 1;
    // color: #fff;
  }
  .empty-na{
    font-size: 28px;
    // color: #fff;
  }
}
.type-box.active{
  .type-price{
    background: #edb545;
    color: #fff;
  }
}
.result-box{
  padding: 15px;
  font-size: 21px;
  font-weight: 600;
  text-align: center;
  background: #fafafa;
  color: #333;
  line-height: 1;
  font-style: italic;
}
.filter-title{
  font-size: 16px;
  font-weight: 600;
  margin: 10px 15px 0;
}
.airline-scroll{
  max-height: 300px;
  overflow: auto;
  background: #f9f9f9;
  border: 1px solid #ccc;
  margin: 0 15px 20px;
}
.airline-list{
  list-style: none;
  margin: 0;
  padding: 10px;

  li{
    padding: 5px 10px;
    border: 1px solid #d1b47c;
    margin-bottom: 5px;
    background: #fff7e8;
    border-radius: 4px;
    cursor: pointer;
    text-transform: capitalize;
    display: flex;
    justify-content: space-between!important;
    align-items: start;

    &:hover{
      background: #ffe4b1;
      color: #a3700c;
      border: 1px solid #a3700c;
    }
    &.active{
      background: #ffe4b1;
      color: #241e12;
      border: 1px solid #a3700c;
    }
    al-name{
      span{
        line-height: 24px;
      }
    }
    img{
      height: 24px;
      margin-right: 12px;
      background: #fff;
    }
  }
  .al-price{
    white-space: nowrap;
  }
}
.price-range{
  margin: 0 15px;
  display: block;
  text-align: center;
  font-size: 16px;
  font-weight: 600;

  span{
    display: inline-block;
    margin: 0 3px;
  }
}
.slider{
  margin: 0 10px;
}
.refundable{
  display: block;
  text-align: center;

  input{
    margin-right: 3px;
    vertical-align: -1px;
  }
}
.leg-tabs{
  border-bottom: 1px solid #f0f0f0;
  padding: 5px 10px;

  .tab{
    padding: 5px;
    text-align: center;
    width: 100%;
    font-weight: 600;
    color: #656565;
    cursor: pointer;

    &.active{
      outline: 2px solid #1474a9;
      color: #1474a9;
      background: #f5fbff;
    }
  }
}
.time-list{
  list-style: none;
  margin: 0 5px 20px;
  padding: 10px;
  font-size: 14px;

  li{
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    cursor: pointer;

    &:last-child{
      margin-bottom: 0;
    }
    .fa-check-square{
      color: #49aee7;
    }
  }
}
@media only screen and (max-width: 641px) {
  .show-on-mobile{
    display: block;
  }
}

@media only screen and (max-width: 500px) {
  .div-field.departure{
    span{
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?40d46dab